<template>
 <div class="goodDetail" :style="isError||!isData?{paddingBottom:'0px'}:{}">
   <openApp :pageName="`goodsDetail?goodsId=${goodsId}&backName=1&goodsKind=${goodsKind}&recommendUserUcode=${recommendUserUcode}`" />
   <!-- <div class="top-nav" v-if="isScrollToBo">
     <div :style="{height:statusBarHeight+'px'}" v-if="!isWechat"></div>
      <van-nav-bar
          title="商品详情"
          left-arrow
          @click-left="back"
      />
  </div> -->
   <div v-if="isData">
      <div class="detail-head">
        <div class="bg">
          <van-icon name="arrow-left" @click="back" :style="{top:statusBarHeight>0?(statusBarHeight+'px'):'1rem'}"/>
         
           <!-- <span v-if="detailObj.taskType" class="cType">{{type}}</span> -->
            <!-- 商品图/视频 -->
            <van-swipe class="goods-img-box" @change="onChangeSwipe" v-if="detailObj.mallTrainingGoodsDetail.picUrlList">
                <van-swipe-item v-if="detailObj.mallTrainingGoodsDetail.videoValue">
                    <!-- 视频 -->
                    <div class="video-box">
                       <!-- <video-player
                            class="video-player vjs-custom-skin"
                            ref="videoPlayerinfo"
                            :playsinline="true"
                            :options="playerOptions">
                        </video-player> -->
                        <VideoPlayerVue
                          ref="videoPlayerRef"
                          :coverUrl="coverUrl"
                        />
                    </div>
                </van-swipe-item>
                <van-swipe-item v-for="(pic,index) in detailObj.mallTrainingGoodsDetail.picUrlList" :key="index">
                    <!-- 图片 -->
                    <div class="image-box">
                        <van-image
                            fit="contain"
                            :src="pic?pic:''"
                        />
                    </div>
                </van-swipe-item>
                <template #indicator>
                    <div class="custom-indicator">{{ swipeCurrent + 1 }}/{{(detailObj.mallTrainingGoodsDetail.picUrlList?detailObj.mallTrainingGoodsDetail.picUrlList.length:0)+(detailObj.mallTrainingGoodsDetail.videoValue?1:0)}}</div>
                </template>
            </van-swipe>
            <img class="courseImg" :src="detailObj.picUrl" v-else/>
        </div>
          <div class="detail-box">
                <div class="detail-title">
                    <span class="secKill-tag" v-if="detailObj.secKillActivity&&detailObj.secKillActivity.curPeriod">秒杀</span>
                    <span>{{detailObj.name}}</span>
                    <img src="../../../assets/images/courseGoods/cert-icon.png" v-if="detailObj && detailObj.hasCert" class="icon" alt="">
                </div>
                <!-- <div class="label">
                    <span class="label1">养老护理员</span>
                    <span class="label2">养老护理员</span>
                    <span class="label3">高级</span>
                </div> -->
                <div class="h2-title" v-if="detailObj.mallTrainingGoodsDetail.goodsSellingPoint">{{detailObj.mallTrainingGoodsDetail.goodsSellingPoint}}</div>
                <!-- <ul class="tag-list-detail">
                    <li class="tag-item tag-active "
                    v-for="(tag, index) in detailObj.labelNameList"
                    :key="index"
                    >
                        <div class="text-tag">{{tag}}</div>
                    </li>
                </ul> -->
                <div class="tag-list" v-if="detailObj.labelNameList&&detailObj.labelNameList.length">
                    <div v-for="(tag,index) in detailObj.labelNameList" :key="index" class="tag-item">{{tag}}</div>
                </div>
                <!-- 课时 视频数 -->
                <ul class="video-course">
                  <li class="item" v-show="detailObj.videoNum"><span class="num">{{detailObj.videoNum}}</span><span class="text">视频</span></li> 
                  <li class="bar" v-show="detailObj.videoNum && detailObj.studyHoursNum"></li>
                  <li class="item" v-show="detailObj.studyHoursNum"><span class="num">{{detailObj.studyHoursNum}}</span><span class="text">课时</span></li> 
                  <li class="item right-item" v-show="is_show_my_points&&detailObj.videoNum"><span class="num">{{detailObj.videoNum}}</span><span class="text">积分</span></li> 
                </ul>
                <!-- 报名周期 -->
                <!-- 培训周期 -->
                <div class="zhouqi"> 
                  <p class="sign-time peixun" v-if="detailObj.trainingStartTime && detailObj.trainingEndTime">
                    <span class="label-zhouqi">培训周期：</span>
                    <span class="time-detail">{{formatDate(detailObj.trainingStartTime)}} - {{formatDate(detailObj.trainingEndTime)}}</span>
                  </p>
                  <p class="sign-time peixun" v-else-if="detailObj.cycleType === 3">
                    <span class="label-zhouqi">培训周期：</span>
                    <span class="time-detail">长期有效</span>
                  </p>
                  <p class="sign-time peixun" v-else-if="detailObj.cycleType === 2">
                    <span class="label-zhouqi">培训周期：</span>
                    <span class="time-detail">报名后{{detailObj.finishDays}}天内有效</span>
                  </p>
                </div>
                <div class="zhouqi"> 
                  <p class="sign-time" v-show="detailObj.signUpStartTime && detailObj.signUpEndTime">
                    <span class="label-zhouqi">报名周期：</span>
                    <span class="time-detail">{{formatDate(detailObj.signUpStartTime)}} - {{formatDate(detailObj.signUpEndTime)}}</span>
                  </p>
                </div>
                <!-- 职业工种等 -->
                <ul class="zhiye-list" v-if="detailObj.profession || detailObj.workType || (detailObj.workType && detailObj.skillLevel)">
                  <li class="zhiye-item" v-if="detailObj.profession">
                    <span class="icon"></span>
                    <span class="label-zhiye">所属职业：</span>
                    <span class="label-text">{{detailObj.profession}}</span>
                  </li>
                  <li class="zhiye-item" v-if="detailObj.workType && detailObj.skillLevel">
                    <span class="icon"></span>
                    <span class="label-zhiye">技能等级：</span>
                    <span class="label-text">{{detailObj.skillLevel}}</span>
                  </li>
                  <li class="zhiye-item" v-if="detailObj.workType">
                    <span class="icon"></span>
                    <span class="label-zhiye" >所属工种：</span>
                    <span class="label-text">{{detailObj.workType}}</span>
                  </li>
                </ul>
                 <!-- v-if="detailObj.secKillActivity&&!detailObj.secKillActivity.curPeriod" -->
                <div class="seckill-box" v-if="detailObj.secKillActivity&&!detailObj.secKillActivity.curPeriod">
                  秒杀预告：{{detailObj.secKillActivity.startTime.substring(0,10)}}至{{detailObj.secKillActivity.endTime.substring(0,10)}} {{detailObj.secKillActivity.startPeriod.substring(11,16)}}-{{detailObj.secKillActivity.endPeriod.substring(11,16)}} 
                  <br>秒杀价格：￥{{detailObj.secKillActivity.price}}
                  <!-- 秒杀预告：2022-08-09至2022-09-21 14:00-15:00 <br>秒杀价格：￥9.9 -->
                </div>
                <div class="price-box" v-if="!detailObj.hidePriceTag">
                  <template v-if="detailObj.secKillActivity&&detailObj.secKillActivity.curPeriod">
                    <span class="price">¥{{detailObj.secKillActivity.price}}</span>
                    <span class="or-price">￥{{detailObj.salePrice}}</span>
                  </template>
                  <template v-else>
                    <template v-if="$route.query.goodsKind == 2">
                      <template v-if="detailObj.shoppingGroup">
                        <span class="price">¥{{detailObj.shoppingGroup.price}}</span>
                      </template>
                      <template v-else>
                        <span class="price" v-if="detailObj.isFree">{{ setFreeString() }}</span>
                        <span class="price" v-else>¥{{detailObj.salePrice}}</span>
                        <span class="or-price" v-if="detailObj.basePrice">￥{{detailObj.basePrice}}</span>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="detailObj.shoppingGroup">
                        <span class="price">¥{{detailObj.shoppingGroup.price}}</span>
                      </template>
                      <template v-else>
                        <span class="price" v-if="detailObj.mallTrainingGoodsDetail.priceType==1">{{ setFreeString() }}</span>
                          <span
                              class="price"
                              v-else-if="detailObj.mallTrainingGoodsDetail.priceType == 0 || detailObj.mallTrainingGoodsDetail.priceType == 2">
                              {{ detailObj.salePrice == 0 ?  setFreeString()  :`¥${detailObj.salePrice}` }}
                          </span>
                          <span class="price" v-else-if="detailObj.mallTrainingGoodsDetail.priceType==3">¥{{detailObj.salePrice}}-{{detailObj.mallTrainingGoodsDetail.highestSalePrice}}</span>
                          <span
                              class="or-price"
                              v-if="[0,1,2].includes(detailObj.mallTrainingGoodsDetail.priceType) &&
                                  detailObj.basePrice
                              "
                              >￥{{ detailObj.basePrice }}
                          </span>
                      </template>
                    </template>
                  </template>
                </div>
                <div class="detail-price">
                    <span class="detail-lasttime">
                      <!-- <span class="detail-lasttime label-color" >有效期：</span>{{time}} -->
                    </span>
                    <span v-if="isJoinPer=='true'" class="persons">{{detailObj.basicOrderNum?(detailObj.basicOrderNum+detailObj.purchaseNo):detailObj.purchaseNo}}人已报名</span>
                </div>
          </div>
      </div>
      <!-- 拼团队列 -->
      <div class="shopgroup-box" v-if="this.detailObj.shoppingGroup&&this.detailObj.shoppingGroup.orderGroupList&&this.detailObj.shoppingGroup.orderGroupList.length&&detailObj.status==1&&!detailObj.isOrder&&((detailObj.shoppingGroup&&!detailObj.orderGroup)||(detailObj.orderGroup&&detailObj.orderGroup.status==9))">
        <div class="sg-title">{{this.detailObj.shoppingGroup.orderGroupList.length}}人在拼单，可直接参与</div>
        <div class="sg-list">
          <div class="sg-list-item">
            <div class="item-left">
              <img class="user-img" :src="this.detailObj.shoppingGroup.orderGroupList[0].headImage?this.detailObj.shoppingGroup.orderGroupList[0].headImage:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/mr-img.png'"/>
              <div class="user-name">{{this.detailObj.shoppingGroup.orderGroupList[0].name}}</div>
            </div>
            <div class="item-right">
              <div class="sg-box">
                <div class="sg-num">还差1人拼成</div>
                <div class="sg-time">剩余{{this.gpobj1.days}}天 {{this.gpobj1.hours}}:{{this.gpobj1.minutes}}:{{this.gpobj1.seconds}}</div>
              </div>
              <div class="sg-btn" @click="showGroupDialog(1)"><div>去拼单</div></div>
            </div>
          </div>
          <div class="sg-list-item" v-if="this.detailObj.shoppingGroup.orderGroupList.length>=2">
            <div class="item-left">
              <img class="user-img" :src="this.detailObj.shoppingGroup.orderGroupList[1].headImage?this.detailObj.shoppingGroup.orderGroupList[1].headImage:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/mr-img.png'"/>
              <div class="user-name">{{this.detailObj.shoppingGroup.orderGroupList[1].name}}</div>
            </div>
            <div class="item-right">
              <div class="sg-box">
                <div class="sg-num">还差1人拼成</div>
                <div class="sg-time">剩余{{this.gpobj2.days}}天 {{this.gpobj2.hours}}:{{this.gpobj2.minutes}}:{{this.gpobj2.seconds}}</div>
              </div>
              <div class="sg-btn" @click="showGroupDialog(2)"><div>去拼单</div></div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-type" v-if="is_show_goodsedit_courseInfo">
        <div class="c-type">
            <div class="tp">课程类型</div>
            <div class="tp-text">{{detailObj.mallTrainingGoodsDetail.courseType==1?'正式课':'体验课'}}</div>
        </div>
        <div class="c-num">
            <div class="tp">上课人数</div>
            <div class="tp-text">{{detailObj.mallTrainingGoodsDetail.classAttendance&&detailObj.mallTrainingGoodsDetail.classAttendance!=0?detailObj.mallTrainingGoodsDetail.classAttendance:'不限'}}</div>
        </div>
        <div class="c-xs" v-if="detailObj.mallTrainingGoodsDetail.teachingForm">
            <div class="tp">授课形式</div>
            <div class="tp-text-box">
                <div class="tp-text" v-for="type in detailObj.mallTrainingGoodsDetail.teachingForm" :key="type">{{teachTypeList[type-1]}}</div>
            </div>
        </div>
      </div>
      <!-- 机构信息 -->
        <div class="block-item organization-info" v-if="isShowBranch&&branchInfo">
            <div class="title">机构信息</div>
            <div class="organization-detail-box">
                <div class="organization-logo" @click="toBranch(branchInfo.branchId)"><img :src="branchInfo.logoImg?branchInfo.logoImg:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-h5-fe/study/morenLogo.png'"/></div>
                <div class="organization-detail" @click="toBranch(branchInfo.branchId)">
                    <div class="organization-title an-ellipsis">
                        {{branchInfo.branchName}}
                    </div>
                    <div class="organization-address">
                        <div class="address-text"><span>{{branchInfo.provinceName + branchInfo.cityName + branchInfo.countyName + branchInfo.address}}</span></div>
                    </div>
                </div>
                <!-- <div class="phone" v-if="!isApp"><a :href="'tel:4008555686'"><img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon-phone.png"/></a></div> -->
                <div class="phone"><img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon-phone.png" @click="handlePhone"/></div>
            </div>
        </div>
      <div class="detail-content">
          <van-tabs v-model="active" @click="onChange" :class="isTab=='true'&&detailObj.goodsType!=3&&catalogList&&catalogList.length>0?'':'wd32'">
              <van-tab title="简介">
                <!-- <img class="courseImg" :src="detailObj.imgUrl"/> -->
                <div class="introCode">
                    <div class="introCode-item" v-if="detailObj.mallTrainingGoodsDetail.applicableObject">
                      <div class="introCode-title" v-if="(detailObj.mallTrainingGoodsDetail.learningObjectives||detailObj.mallTrainingGoodsDetail.courseHighlights||detailObj.mallTrainingGoodsDetail.description)"><div class="in-line"></div><div class="in-title">适用对象</div></div>
                      <div class="introCode-text" v-html="detailObj.mallTrainingGoodsDetail.applicableObject"></div>
                    </div>
                    <div class="introCode-item" v-if="detailObj.mallTrainingGoodsDetail.courseHighlights">
                      <div class="introCode-title" v-if="(detailObj.mallTrainingGoodsDetail.learningObjectives||detailObj.mallTrainingGoodsDetail.description||detailObj.mallTrainingGoodsDetail.applicableObject)"><div class="in-line"></div><div class="in-title">课程亮点</div></div>
                      <div class="introCode-text" v-html="detailObj.mallTrainingGoodsDetail.courseHighlights"></div>
                    </div>
                    <div class="introCode-item" v-if="detailObj.mallTrainingGoodsDetail.learningObjectives">
                      <div class="introCode-title" v-if="(detailObj.mallTrainingGoodsDetail.description||detailObj.mallTrainingGoodsDetail.courseHighlights||detailObj.mallTrainingGoodsDetail.applicableObject)"><div class="in-line"></div><div class="in-title">培养目标</div></div>
                      <div class="introCode-text" v-html="detailObj.mallTrainingGoodsDetail.learningObjectives"></div>
                    </div>
                    <div class="introCode-item" v-if="detailObj.mallTrainingGoodsDetail.description">
                      <div class="introCode-title" v-if="(detailObj.mallTrainingGoodsDetail.learningObjectives||detailObj.mallTrainingGoodsDetail.courseHighlights||detailObj.mallTrainingGoodsDetail.applicableObject)"><div class="in-line"></div><div class="in-title">内容介绍</div></div>
                      <div class="introCode-text" v-html="detailObj.mallTrainingGoodsDetail.description"></div>
                    </div>
                </div>
                </van-tab>
              <van-tab title="目录" v-if="isTab=='true'&&detailObj.goodsType!=3&&catalogList&&catalogList.length>0">
                  <div class="list">
                      <!-- <courseItem :itemList="catalogList" :num="0" :isFirst="isFirst" :goodsId="goodsId" :sort="1" :isOverType="isOverType" :detailObj="detailObj" :isApp="isApp"></courseItem> -->
                      <courseItem :itemList="catalogList" :num="0" :isFirst="isFirst" :goodsId="goodsId" :sort="1"  :isOverType="isOverType" :detailObj="detailObj"></courseItem>
                  </div>
              </van-tab>
          </van-tabs>
      </div>
      <div class="block-item other-list" v-if="isShowTj && coruseList.length">
            <div class="title">本机构课程推荐</div>
            <coruseList :list="coruseList" :type="1"/>
        </div>
      <div class="myTorst" v-show="showT">
        <img src="../../../assets/images/courseGoods/bingo.png" class="bingo"/>
        <div>已成功加入</div>
      </div>
      <!-- <div class="detail-foot"> -->
          <!-- <button @click="enroll" v-if="isShowNowSignUp && detailObj.status==1&&!detailObj.isOrder">立即报名</button> -->
          <!-- <div v-else-if="detailObj.status==1&&detailObj.isOrder"> -->
            <!-- 测评 -->
            <!-- <template v-if="detailObj.goodsType == 3">
              <button class="rightBtn" @click="isToStudy" :class="isOverType=='oks'?'':'downClass'">{{isOver}}</button>
            </template> -->
            <!-- 培训任务、训练营 -->
            <!-- <template v-else-if="canToQuicklyStudy"> -->
              <!-- <button class="leftBtn" @click="isToStudy" :class="isOverType=='oks'?'':'downClass'">任务大纲</button> -->
              <!-- <button class="rightBtn" @click="quicklyStudy" :class="isOverType=='oks'?'':'downClass'">{{isOver}}</button>
            </template>
            <template v-else> -->
              <!-- <button @click="isToStudy" :class="isOverType=='oks'?'':'downClass'">{{isOver}}</button> -->
            <!-- </template> -->
          <!-- </div> -->
          <!-- <button @click="isToStudy" :class="isOverType=='oks'?'':'downClass'" v-else-if="detailObj.status==1&&detailObj.isOrder">{{isOver}}</button> -->
          <!-- <button v-else-if="isShowNowSignUp" style="background: #E2E2E2;" class="downClass">{{statusText}}</button> -->
      <!-- </div> -->
      <div class="bottom-fixed">
        <div class="buy-bar-box">
            <div class="buy-handle-box">
                <div class="buy-handle-item" v-if="isShowShareBtn" @click="shareOut(1)">
                   <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon-share.png"/>
                    <div>分享</div>
                </div>
                <!-- <div class="buy-handle-item" v-if="false&&isApp" @click="shareOut(2)">
                    <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/ic-gift.png"/>
                    <div>分享有礼</div>
                </div> -->
                <div class="buy-handle-item" v-if="detailObj.mallTrainingGoodsDetail.transformationGuidanceList&&detailObj.mallTrainingGoodsDetail.transformationGuidanceList.indexOf(1)!=-1&&detailObj.status==1&&!detailObj.isOrder&&isShowZXicon">
                    <!-- <a :href="'tel:4008555686'" v-if="!isApp" @click="handlePhone">
                      <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon-phone.png"/>
                      <div>电话</div>
                    </a> -->
                    <!-- <template v-else> -->
                      <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon-phone.png" @click="handlePhone"/>
                      <div @click="handlePhone">电话</div>
                    <!-- </template> -->
                </div>
                <div class="buy-handle-item" @click="handleServe" v-if="detailObj.mallTrainingGoodsDetail.transformationGuidanceList&&detailObj.mallTrainingGoodsDetail.transformationGuidanceList.indexOf(1)!=-1&&detailObj.mallTrainingGoodsDetail.transformationGuidanceList.indexOf(2)!=-1&&isShowZXicon">
                    <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon-qus.png"/>
                    <div>在线咨询</div>
                </div>
                <div class="buy-handle-item" v-if="detailObj.status==1&&detailObj.isOrder" @click="isToStudy">
                    <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon-dg.png"/>
                    <div>任务大纲</div>
                </div>
            </div>
            <div class="detail-btn btn-ask" v-if="detailObj.mallTrainingGoodsDetail.transformationGuidanceList&&detailObj.mallTrainingGoodsDetail.transformationGuidanceList.indexOf(1)!=-1&&detailObj.mallTrainingGoodsDetail.transformationGuidanceList.indexOf(2)==-1&&isShowZXicon"  @click="handleServe">在线咨询</div>
            <template v-else-if="detailObj.mallTrainingGoodsDetail.transformationGuidanceList&&detailObj.mallTrainingGoodsDetail.transformationGuidanceList.indexOf(2)!=-1">
              <!-- 商品设置拼团未发起拼团 -->
              <div class="detail-btn btn-dough" v-if="(isShowNowSignUp && detailObj.status==1&&!detailObj.isOrder&&detailObj.shoppingGroup&&!detailObj.orderGroup)||(isShowNowSignUp && detailObj.status==1&&!detailObj.isOrder&&detailObj.shoppingGroup&&detailObj.orderGroup&&detailObj.orderGroup.status==9)">
                <div class="one-buy" @click="enroll(1)">
                  <div class="one-price">￥{{detailObj.secKillActivity&&detailObj.secKillActivity.curPeriod?detailObj.secKillActivity.price:detailObj.salePrice}}</div>
                  <div>单独购买</div>
                </div>
                <div class="two-buy" @click="enroll(2)">
                  <div class="two-price">￥{{detailObj.shoppingGroup.price}}</div>
                  <div>发起拼团</div>
                </div>
              </div>
              <!-- 商品设置拼团且发起拼团 -->
              <div class="detail-btn btn-dough-success" @click="toGroup" v-if="isShowNowSignUp && detailObj.status==1&&detailObj.shoppingGroup&&detailObj.orderGroup&&detailObj.orderGroup.status==0">
                查看拼团详情
              </div>
              <!-- 普通商品购买 -->
              <div class="detail-btn btn-buy" @click="enroll(1)" v-if="isShowNowSignUp && detailObj.status==1&&!detailObj.isOrder&&!detailObj.shoppingGroup">立即报名</div>
              <!-- 商品设置拼团且拼团成功 -->
              <div class="detail-btn btn-study" @click="isToStudy" :class="isOverType=='oks'?'':'downClass'" v-else-if="detailObj.status==1&&detailObj.isOrder">{{isOver}}</div>
              <button v-else-if="isShowNowSignUp&&detailObj.status!=1" style="background: #D8D8D8;border:0;" class="detail-btn downClass">{{statusText}}</button>
            </template>
            <template v-else>
              <div class="detail-btn btn-buy" @click="enroll(1)" v-if="isShowNowSignUp && detailObj.status==1&&!detailObj.isOrder&&!detailObj.shoppingGroup">立即报名</div>
              <div class="detail-btn btn-study" @click="isToStudy" :class="isOverType=='oks'?'':'downClass'" v-else-if="detailObj.status==1&&detailObj.isOrder">{{isOver}}</div>
              <button v-else-if="isShowNowSignUp&&detailObj.status!=1" style="background: #D8D8D8;border:0;" class="detail-btn downClass">{{statusText}}</button>
            </template>
        </div>
        <div :style="{height:bottomSafeHeight+'px'}"></div>
      </div>
   </div>
    <div v-else class="loadingBox">
      <div v-if="!isError">
        <van-loading type="spinner" color="#1989fa" />
        <div>加载中...</div>
      </div>
      <div v-else class="error-box">
        <div class="error-img"><van-icon name="warning" /></div>
        <div class="error-message">{{errorMessage}}</div>
        <div class="error-back" @click="back">返回</div>
      </div>
    </div>
    <!-- <div class="share-tip" v-show="isShareShow">
        <p>点击右上角···<br>转发给指定好友或分享到朋友圈</p>
    </div> -->
    <van-dialog class="orderTip" confirm-button-color="#316FFF" confirm-button-text="订单列表" v-model="showOrderTip" title="" show-cancel-button @confirm="toOrderList" @cancel="showOrderTip=false">
      {{message}}
    </van-dialog>
    <!-- 拼团弹框 -->
    <van-dialog v-model="showGroupPurchDialog" :show-confirm-button="false" class="groupPurchDialog">
      <div class="cancel-btn"><img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/close-dialog.png" @click="showGroupPurchDialog=false"/></div>
      <div class="groupPurchDialog-content" v-if="this.clickOrder">
        <div class="content-title">参与<span>{{this.clickOrder.name}}</span>的拼单</div>
        <div class="content-time" v-if="this.clickOrder.type==1">仅剩1个名额，{{this.gpobj1.days}}天 {{this.gpobj1.hours}}:{{this.gpobj1.minutes}}:{{this.gpobj1.seconds}}后失效</div>
        <div class="content-time" v-else-if="this.clickOrder.type==2">仅剩1个名额，{{this.gpobj2.days}}天 {{this.gpobj2.hours}}:{{this.gpobj2.minutes}}:{{this.gpobj2.seconds}}后失效</div>
        <div class="content-list">
          <div class="header-img"><img class="pz-tip" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/pz-tip.png"/><img :src="this.clickOrder.headImage?this.clickOrder.headImage:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/mr-img.png'"/></div>
          <div class="header-img"><img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/wjr-img.png"/></div>
        </div>
        <div class="join-btn"><img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/cypd-btn.png" @click="grouppurchase"/></div>
      </div>
    </van-dialog>
    <van-popup v-model="showSharePoster" class="sharePoster">
       <div class="sharePoster-content" id="sharePoster" ref="sharePoster">
        <img class="poster-bg" :src="posterBase64Url.posterBg"/>
        <div class="branch-name" :style="{color:randomNum==3?'#5A2D0B':randomNum==2?'#012DCC':'#fff'}">{{detailObj.branchName}}</div>
        <div class="course-box">
          <div class="course-img"><img :src="posterBase64Url.courseImg"/></div>
          <div class="course-title">{{detailObj.name}}</div>
        </div>
        <div id="qrcode" ref="qrCodeDiv"></div>
      </div>
      <img class="wechatPoster" v-if="posterBase64Url.base64Url" :src="posterBase64Url.base64Url"/>
        <div class="join-btn" v-if="!isWechat&&!isDing&&posterBase64Url.base64Url"><img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/saveincamare.png" @click="downloadPoster"/></div>
        <div class="in-btn" v-else-if="posterBase64Url.base64Url">请长按海报保存至本地</div>
        <div class="in-btn"><van-loading v-if="!posterBase64Url.base64Url" size="24px" color="#ffffff">海报生成中，请稍后...</van-loading></div>
        <div class="cancel-btn"><img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/close-poster.png" @click="showSharePoster=false"/></div>
    </van-popup>
     <!-- 授权弹窗 -->
    <van-dialog
      title="东堃用户隐私授权协议"
      v-model="empowerDialog"
      class="empower-dialog"
      @confirm="confirmAgree"
      @cancel="cancelAgree"
      :show-confirm-button="true"
      :show-cancel-button="true"
      :before-close="onBeforeClose"
    >
      <empower v-model="isAgreeEmpower"/>
    </van-dialog>
 </div>
</template>

<script>
import dayjs from 'dayjs'
import courseItem from './courseItem.vue';
import { Toast,Dialog } from 'vant';
// import goodsList from './components/goodsList.vue';
import coruseList from './components/coruseList.vue';
import VideoPlayerVue from "./components/VideoPlayer.vue";
import openApp  from './components/openApp.vue'
import share from '../../../utils/share';
import Applogo from '../asset/images/app_logo.png'
import {sensorsMixin} from './mixins/sensors'
import html2canvas from 'html2canvas'
import QRCode from 'qrcodejs2'
import Empower from './components/empower'
// import $ from "jquery";
export default {
    name: "courseGoodsDetail",
    mixins: [sensorsMixin],
    beforeRouteLeave(to,from, next) {
        this.leavePage();
        next();
    },
    components: {
        courseItem,
        // goodsList,
        coruseList,
        VideoPlayerVue,
        openApp,
        Empower
    },
    data () {
        return {
          isFreePriceChangeName:false,
          showSharePoster:false,
          showGroupPurchDialog:false,
          showOrderTip:false,
          message:'',
            len: self.history.length,
            statusBarHeight:0,
            bottomSafeHeight:0,
            is_show_goodsedit_courseInfo:false, //课程信息显示配置
            is_show_my_points:false,
            // isNotApp:this.$route.query.isApp?1:0,
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            isDing:false,
            coverUrl:'',
            title:'商品详情',
            showT:false,
            goodsId:parseInt(this.$route.query.goodsId),//商品ID
            goodsKind: this.$route.query.goodsKind,
            isData:false,
            otherList:[],
            // entityParams:{
            //     name: '',
            //     sortType: 0,
            //     pageNum:1,
            //     pageSize:2,
            //     hasBranchInfo:false,
            // },
            mallParams:{
                name: '',
                sort: 1,
                vocationCodes:"",
                exceptIdList:[],
                branchId:''
            },
            pageParams:{
                pageNum:1,
                pageSize:2,
            },
            teachTypeList:[
              '线下面授',
              '线上录播',
              '线上直播'
            ],
            swipeCurrent:0,
            isScrollToBo:false,
            //推荐课程列表
            coruseList:[],
            // detailData: {
            //     // 商品图
            //     goods: [
            //         {
            //             value: '视频',
            //             type: 1,
            //             id: 1232,
            //         },
            //         {
            //             value: '图片',
            //             type: 2,
            //             id: 45435,
            //         }
            //     ],
            //     goodsId: 1,
            // },
            // playerOptions: {
            //     //播放速度
            //     // playbackRates: [0.5, 1.0, 1.5, 2.0], 
            //     //如果true,浏览器准备好时开始回放。
            //     autoplay: true,
            //     // 默认情况下将会消除任何音频。
            //     muted: true, 
            //     // 导致视频一结束就重新开始。
            //     loop: false, 
            //     // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            //     preload: 'auto', 
            //     language: 'zh-CN',
            //     // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            //     aspectRatio: '16:9',
            //     // 当true时，Video.js player将拥有流体大小。换句话说,它将按比例缩放以适应其容器。
            //     fluid: true,
            //     sources: [{
            //         //类型
            //         type: "video/mp4",
            //         //url地址
            //         src: ''
            //     }],
            //     //你的封面地址
            //     poster: '', 
            //     //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            //     notSupportedMessage: '此视频暂无法播放，请稍后再试',
            //     controlBar: {
            //         timeDivider: true,
            //         durationDisplay: true,
            //         remainingTimeDisplay: false,
            //         //全屏按钮
            //         fullscreenToggle: false  
            //     },
            //     // skinLayout: [{ name: 'bigPlayButton', align: 'cc' }],
            // },
            detailObj:{
              basePrice: 0,//划线价格
              days: 0,//购买多少天有效
              desc: "",//简介
              endTime: "",
              goodsType: 1,//商品引用类型1.训练营 2.培训任务
              id: 0,
              isFree: 1,//是否免费
              isOrder: 0,//是否已经购买 0 否 1 是
              name: "",//商品名称
              picUrl: "",
              purchaseNo: 0,//报名人数
              referId: 0,//商品引用ID
              salePrice: 0,//销售价格
              startTime: "",
              status: 0,//状态 0下架 1上架 2 待上架
              taskType: 0,//任务类型 1.必修课 2.选修课 3.公开课
              tryWatch: 0,//商品有效期类型（1:永久有效、2:期间、3:固定时间、4:购买后期间）
              tryWatchList: [//可试看列表
                {
                  itemId: 0,
                  value: 0
                }
              ],
              validityType: 1//有效期类型
            },
          active:0,
          catalogList:[//目录列表
          ],
          isFirst:true,//是否一级
          isTab:'true',
          isJoinPer:'true',
          isShowNowSignUp: true,
          lastStudyCourseId:'',
          lastPlayItemId:'',
          taskId:'',
          canToQuicklyStudy:false,
          firstStudy:true,// 是否已经学过了
          isShowTj:false,
          isShowShareBtn:false,
          isShowBranch:false,
          // isApp:false,
          isWd:this.$route.query.isWd?true:false,
          fromName:'',
          isError:false,
          errorMessage:'',
          branchInfo:{},
          recommendUserUcode:'',
          // isShareShow:false,
          isShowZXicon:false,
          gpobj1:{
            timer:null,
            days:'00',
            hours:'00',
            minutes:'00',
            seconds:'00',
            residue:'',
            counts:'',
          },
          gpobj2:{
            timer:null,
            days:'00',
            hours:'00',
            minutes:'00',
            seconds:'00',
            residue:'',
            counts:'',
          },
          clickOrder:{
            // activityId:1,
            // activityRuleId:1,
            // activityRuleItemId:1,
            // curTime:'2022/09/08',
            // expireTime:'2022/09/09',
            // groupId:1,
            // headImage:'',
            // name:'我的名字',
            // type:1
          },
          randomNum:0,
          sharePosterList:[
            'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/kcfxbg1.png',
            'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/kcfxbg2.png',
            'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/kcfxbg3.png',
            'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/kcfxbg4.png',
            'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/kcfxbg5.png',
          ],
          posterBase64Url:{
            posterBg:'',
            courseImg:'',
            base64Url:''
          },
          isCreatedPoster:true,
          showPosterNum:0,
          empowerDialog:false,
          isAgreeEmpower:0, //isAgreeEmpower
          isDongkun:'false',//是否为东堃
        };
    },
    computed: {
      //课程类型
      type(){
        if(this.detailObj.taskType==1){
          return '必修课'
        }else if(this.detailObj.taskType==2){
          return '选修课'
        }else{
          return '公开课'
        }
      },
        //上架状态
      statusText(){
        if(this.$route.query.goodsKind == 1){
            if(this.detailObj.status==1){
                  return '上架'
              }else if(this.detailObj.status==0){
                  return '下架'
              }else {
                  return '待上架'
              }
        }else {
              if(this.detailObj.status==1){
                  return '上架'
              }else if(this.detailObj.status==2){
                  return '下架'
              }else {
                   return '待上架'
              }
        }
      },
      
      //是否过期文案显示
      isOver(){
        if(this.detailObj.endTime&&this.detailObj.validityType==4){
          let lastTime = new Date(this.detailObj.endTime.replace(/-/g,'/')).getTime(); 
          let nowTime = new Date().getTime();
          if(lastTime>nowTime){
            return this.firstStudy ?'立即学习':'继续学习'
          }else{
            return '已过期'
          }
        }else if(this.detailObj.endTime&&(this.detailObj.validityType==2||this.detailObj.validityType==3)){
          let lastTime = new Date(this.detailObj.endTime.replace(/-/g,'/')).getTime(); 
          let startTime = new Date(this.detailObj.startTime.replace(/-/g,'/')).getTime(); 
          let nowTime = new Date().getTime();
          if(lastTime>=nowTime&&startTime<=nowTime){
            return this.firstStudy ?'立即学习':'继续学习'
          }else{
            if(startTime>nowTime){
              return '未开始'
            }else{
              return '已过期'
            }
          }
        }else{
          return this.firstStudy ?'立即学习':'继续学习'
        }
      },
      //是否过期
      isOverType(){
        if(this.detailObj.isOrder){
          if(this.detailObj.endTime&&this.detailObj.validityType==4){
            let lastTime = new Date(this.detailObj.endTime.replace(/-/g,'/')).getTime();  
            let nowTime = new Date().getTime();
            if(lastTime>=nowTime){
              return 'oks'
            }else{
              return 'no2'
            }
          }else if(this.detailObj.endTime&&(this.detailObj.validityType==2||this.detailObj.validityType==3)){
            let lastTime = new Date(this.detailObj.endTime.replace(/-/g,'/')).getTime(); 
            let startTime = new Date(this.detailObj.startTime.replace(/-/g,'/')).getTime(); 
            let nowTime = new Date().getTime();
            if(lastTime>=nowTime&&startTime<=nowTime){
              return 'oks'
            }else{
              if(startTime>=nowTime){
                return 'no1'
              }else{
                return 'no2'
              }
            }
          }else if(this.detailObj.validityType==1){
            return 'oks'
          }else{
            return 'ok'
          }
        }else{
            return 'ok'
        }
      },
      //有效期
      time(){
        if(this.detailObj.validityType==1){
          return "永久有效"
        }else if(this.detailObj.validityType==2){
          let sarr = this.detailObj.startTime.split(' ');
          let stimeArr = sarr[0].split('-');
          stimeArr[0] = stimeArr[0]+'年';
          stimeArr[1] = stimeArr[1]+'月';
          stimeArr[2] = stimeArr[2]+'日';
          let snewTime = stimeArr.join('');
          let earr = this.detailObj.endTime.split(' ');
          let etimeArr = earr[0].split('-');
          etimeArr[0] = etimeArr[0]+'年';
          etimeArr[1] = etimeArr[1]+'月';
          etimeArr[2] = etimeArr[2]+'日';
          let enewTime = etimeArr.join('');
          return snewTime+"-"+enewTime
        }else if(this.detailObj.validityType==3){
           if(this.detailObj.startTime&&this.detailObj.endTime){
              let sarr = this.detailObj.startTime.split(' ');
              let stimeArr = sarr[0].split('-');
              stimeArr[0] = stimeArr[0]+'年';
              stimeArr[1] = stimeArr[1]+'月';
              stimeArr[2] = stimeArr[2]+'日';
              let snewTime = stimeArr.join('');
              let earr = this.detailObj.endTime.split(' ');
              let etimeArr = earr[0].split('-');
              etimeArr[0] = etimeArr[0]+'年';
              etimeArr[1] = etimeArr[1]+'月';
              etimeArr[2] = etimeArr[2]+'日';
              let enewTime = etimeArr.join('');
              return snewTime+"-"+enewTime
           }else{
              let earr = this.detailObj.endTime.split(' ');
              let etimeArr = earr[0].split('-');
              etimeArr[0] = etimeArr[0]+'年';
              etimeArr[1] = etimeArr[1]+'月';
              etimeArr[2] = etimeArr[2]+'日';
              let enewTime = etimeArr.join('');
              return "至"+enewTime
           }
        }else{
          return "报名后"+this.detailObj.days+"天内有效"
        }
      }
    },
    watch:{
        // 被侦听的变量showPosterNum
        showPosterNum(){
            console.log('showPosterNum 发生了变化');
            console.log(this.showPosterNum)
            if(this.showPosterNum==2){
              setTimeout(()=>{
                this.qrcode();
              },10)
            }
        }
    },
    async created(){
      if(window.navigator.userAgent.includes("DingTalk")){
        this.isDing = true;
      }
      // localStorage.setItem('shurl',window.location.href.split('#')[0]);
      if(localStorage.getItem('statusBarHeight')){
        this.statusBarHeight = localStorage.getItem('statusBarHeight');
        this.bottomSafeHeight = localStorage.getItem('bottomSafeHeight');
      }else{
        this.statusBarHeight = this.$publicFn.getQueryVariable('statusBarHeight');
        this.bottomSafeHeight = this.$publicFn.getQueryVariable('bottomSafeHeight');
      }
      if(this.$route.query.recommendUserUcode){
        sessionStorage.setItem('recommendUserUcode',this.$route.query.recommendUserUcode);
      }
      this.recommendUserUcode =sessionStorage.getItem('recommendUserUcode');
      this.configMenuInfor();
      sessionStorage.setItem('search',window.location.search)
      this.active = sessionStorage.getItem('theme') === 'minzheng'? 1:0
      let agentIdStorage = localStorage.getItem('detailAgentId')
      localStorage.setItem('detailAgentId', this.$route.query.agentId || agentIdStorage || '')
      if (this.$route.query.form && this.$route.query.form == 'promotionCenter' ) {
        console.log('隐藏立即报名')
        this.isShowNowSignUp = false
      }
      

      var frontendConfig = this.$store.state.dynamic.frontendConfig || [];
      var isTab = frontendConfig.filter((item)=>{
        return item.key == 'is_show_catalog_tab';
      })
      this.isTab = isTab[0].value;

      var isFreePriceChangeName = frontendConfig.filter((item)=>{
        return item.key == 'is_free_price_change_name';
      })
      this.isFreePriceChangeName = isFreePriceChangeName[0].value
      
      var isJoinPer = frontendConfig.filter((item)=>{
        return item.key == 'is_show_commodity_number_buyer_detail_page';
      })
      this.isJoinPer = isJoinPer[0].value;
       
      var isdongkun = frontendConfig.filter((item)=>{
        return item.key == 'is_dongkun_empower';
      })
      this.isDongkun = isdongkun[0].value;
      if(this.isDongkun==='true'){
        this.viewUserAccess();
      }
      if(this.$route.query.goodsKind == 2){
        await this.getDistributionGoodsInfo();// 分销商品详情
      }else {
        await this.getGoodsDetail();// 商品详情
      }
    // 红会定制微信以卡片形式分享
        if(localStorage.getItem('theme')=='honghui'){
          this.configObj = {
            desc:'红十字国际学院',
            imgUrl:this.detailObj.picUrl || this.detailObj?.mallTrainingGoodsDetail?.picUrlList[0],
            title:this.detailObj.name,
            link:window.location.origin+`/goodsDetail?goodsKind=${this.$route.query.goodsKind}&goodsId=${this.goodsId}&fromType=${this.fromType}`
          }
          share.getShare(this,this.configObj)
        }
      const dom = document.getElementById("share-title");
      // dom.src = this.detailObj.picUrl
      // dom.src = 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-mini/app_logo.png'
      document.title = this.detailObj.name
      // console.log('this.showConfig',this.isShowShareBtn)
      // if(this.isWechat && this.isShowShareBtn) {
      //   let recommendUserUcode = localStorage.getItem('token')?JSON.parse(localStorage.getItem('userInfo')).userUcode:'';
      //     share.getShare(this,{
      //         imgUrl: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-mini/app_logo.png',
      //         title: this.detailObj.name,
      //         desc: '点击查看详情',
      //         link:`${window.location.protocol}//${window.location.host}/goodsDetail?goodsId=${this.detailObj.id}&goodsKind=${this.$route.query.goodsKind}&isWd=1&recommendUserUcode=${recommendUserUcode}`
      //     })
      // }
      // this.initPlayer();
    },

    async mounted(){
       if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
        window.addEventListener('scroll',this.handleScroll)
        // this.$WDJSBridge.useGetAppVersion().then(res=>{
        //   console.log('获取版本号成功', res)
        //   this.isApp = res?true:false;
        // }).catch(err=>{
        //   console.log('获取版本号失败', err)
        // })
        const that = this;
        window.addEventListener( 'beforeunload', e => {
            that.leavePage();
        });
        // if(this.isShowShareBtn){
        //   this.randomNum = Math.floor(Math.random()*5);
        //   this.getBase64Image(this.sharePosterList[this.randomNum],1);
        // }
    },
    beforeDestroy() {
      document.title = localStorage.getItem('pageTitle');
    },
    destroyed(){
        window.removeEventListener("popstate", this.back, false); //false阻止默认事件
        window.removeEventListener('scroll',this.handleScroll,false)
        // localStorage.setItem('detailAgentId', this.$route.query.agentId || '')
    },

    methods: {
      
      setFreeString() {
            return this.isFreePriceChangeName && this.isFreePriceChangeName
        },
      onBeforeClose(action,done){
        if(action=='confirm'){
          done(false)
        }else{
          done();
        }
      },
      // 同意协议
      confirmAgree(){
        const that = this;
        if(this.isAgreeEmpower===0){
          this.$notify({
            message:'请勾选同意隐私协议后确认授权',
            type:'warning'
          });
        }else{
          this.$api.renshe.saveUserAccess().then(res=>{
            if(res.code==0){
              this.isAgreeEmpower = 1;
              this.$notify({
                message:'授权成功，您现在可以开始报名了',
                type:'success',
              })
            }else{
              this.isAgreeEmpower = 0;
            }
            this.empowerDialog = false;
          })
        }
      },
      cancelAgree(){
        this.isAgreeEmpower = 0;
        this.$notify({
          message:'授权失败，您暂时不能报名',
          type:'danger',
          duration:2000
        });
      },
      // 东堃查看用户是否同意协议
      viewUserAccess(){
        this.$api.renshe.viewUserAccess().then(res=>{
          if(res.code==0){
            this.isAgreeEmpower = res.data;
          }
        })
      },
      getBase64Image(imgurl,type) {
        //一定要设置为let，不然图片不显示
        let image = new Image();
        //解决跨域问题
        image.setAttribute('crossOrigin', 'anonymous');
        // image.crossOrigin = 'anonymous';
        // image.setAttribute('crossOrigin', '*' )
        // console.log('3333333333',image.crossOrigin)
        image.src = imgurl + '?v=' + Math.random();
        let that = this;
        //image.onload为异步加载
        image.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = image.width
          canvas.height = image.height
          var context = canvas.getContext('2d');
          context.textAlign = 'left';
          context.drawImage(image, 0, 0,image.width, image.height);
          var quality = 1;
          
          //这里的dataurl就是base64类型
          var dataURL = canvas.toDataURL("image/png", quality);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
          if(type==1){
            this.posterBase64Url.posterBg = dataURL;
          }else{
            this.posterBase64Url.courseImg = dataURL;
          }
          this.showPosterNum++;
          // console.log(this.posterBase64Url.posterBg)
        }
      },
      //生成二维码
      qrcode() {
          new QRCode(this.$refs.qrCodeDiv, {
              width: 75,
              height: 75,
              text: `${window.location.protocol}//${window.location.host}/goodsDetail?goodsId=${this.detailObj.id}&goodsKind=${this.$route.query.goodsKind}`, // 二维码地址
              // colorDark: "#000",// 二维码颜色
              // colorLight: "#fff"// 二维码背景色
          });
          setTimeout(()=>{
            this.savePoster();
          },10)
      },
      //海报生成图片
      savePoster(){
        // var shareEl = document.getElementById('sharePoster')
        // if(this.isCreatedPoster){
        //   this.isCreatedPoster = false;
          html2canvas(this.$refs.sharePoster,{
              logging: false, //日志开关，便于查看html2canvas的内部执行流程
              width: this.$refs.sharePoster.clientWidth, //dom 原始宽度
              height: this.$refs.sharePoster.clientHeight,
              scrollY: 0, 
              scrollX: 0,
              useCORS: true // 【重要】开启跨域配置
          }).then(canvas => {
              var imgUrl = canvas.toDataURL("image/png");
              this.posterBase64Url.base64Url = imgUrl;
              // console.log(imgUrl)
          })
        // }
          
      },
      //下载海报至相册
      downloadPoster(){
        const qrLinkEl = document.createElement('a')
        qrLinkEl.setAttribute('href', this.posterBase64Url.base64Url)
        qrLinkEl.setAttribute('download', this.detailObj.name+'.png')
        qrLinkEl.click()
        qrLinkEl.removeAttribute('click')
      },
      //参与拼单
      grouppurchase(){
        this.onTrack('buy_commodity_click',{
          buy_type: this.detailObj.isFree ? '免费' : '付费',
          current_price: this.detailObj.shoppingGroup.price,
        })
        this.$router.push({
          path: "/gongxin_payment",
          query: {
            agentId:localStorage.getItem('detailAgentId') || '',
            goodsId:this.$route.query.goodsId,
            goodsKinds: this.$route.query.goodsKind,
            isGroupGood:2,
            activityGroupId:this.clickOrder.groupId,
            platformActivityRuleItemId:this.clickOrder.activityRuleItemId
          }
        });
                // var data = {
                //     activityGroupId:this.clickOrder.groupId,
                //     // goodsId:this.goodsId,
                //     totalMoney:this.detailObj.shoppingGroup.price,
                //     orderSource:2,
                //     orderType:this.$route.query.goodsKind == 2 ? 4 : this.$route.query.goodsKind==1?localStorage.getItem('detailAgentId')?3:1:null,
                //     agentId: localStorage.getItem('detailAgentId') || '',
                //     distributionUserId:'',
                //     shareUserInfo:'',
                //     goodsList:[{
                //         goodsId:this.$route.query.goodsId,
                //         goodsKinds:this.$route.query.goodsKind,
                //         num:1,
                //         promotionId:'',
                //         salePrice:this.detailObj.shoppingGroup.price
                //     }],
                //     realPay:this.detailObj.shoppingGroup.price,
                //     platformActivityRuleItemId:this.clickOrder.activityRuleItemId
                // }
                // this.$api.courseGoodsDetail.ordertoc({data}).then(res=>{
                //     if(res.code==0){
                //       if(res.data.placeOrderSuccess && res.data.realPayPrice > 0) {
                //         this.$router.push({
                //           path: "/gongxin_payment",
                //           query: {
                //               orderNo: res.data.orderNo,
                //               agentId: localStorage.getItem('detailAgentId') || '',
                //               goodsKinds: this.$route.query.goodsKind,
                //           }
                //         });

                //       } else if(res.data.placeOrderSuccess && res.data.realPayPrice === 0){
                //         this.showT = true;
                //         setTimeout(() => {
                //             this.showT = false;
                //         }, 2000);
                //         this.detailObj.isOrder = 1;
                //       } else {
                //         if(res.data.url) {
                //           window.open(res.data.url, '_self')
                //         } else {
                //           this.$router.go(-1)
                //         }
                //       }
                //     }else if(res.code==50001){
                //       this.message = res.message;
                //       this.showOrderTip = true;
                //     }else{
                //       Toast({
                //         message: res.message,
                //         duration: 2000
                //       })
                //     }
                // })
      },
      //拼团倒计时
      countDown(type) {
        if(type == 1){
          this.gpobj1.days = parseInt(this.gpobj1.counts / (24 * 60 * 60))
          this.gpobj1.days = this.gpobj1.days < 10 ? "0" + this.gpobj1.days : this.gpobj1.days
          this.gpobj1.hours = parseInt(this.gpobj1.counts / (60 * 60) % 24);
          this.gpobj1.hours = this.gpobj1.hours < 10 ? "0" + this.gpobj1.hours : this.gpobj1.hours
          this.gpobj1.minutes = parseInt(this.gpobj1.counts / 60 % 60);
          this.gpobj1.minutes =  this.gpobj1.minutes < 10 ? "0" +  this.gpobj1.minutes :  this.gpobj1.minutes
          this.gpobj1.seconds = parseInt(this.gpobj1.counts % 60);
          this.gpobj1.seconds = this.gpobj1.seconds < 10 ? "0" + this.gpobj1.seconds : this.gpobj1.seconds
        }else if(type==2){
          this.gpobj2.days = parseInt(this.gpobj2.counts / (24 * 60 * 60))
          this.gpobj2.days = this.gpobj2.days < 10 ? "0" + this.gpobj2.days : this.gpobj2.days
          this.gpobj2.hours = parseInt(this.gpobj2.counts / (60 * 60) % 24);
          this.gpobj2.hours = this.gpobj2.hours < 10 ? "0" + this.gpobj2.hours : this.gpobj2.hours
          this.gpobj2.minutes = parseInt(this.gpobj2.counts / 60 % 60);
          this.gpobj2.minutes =  this.gpobj2.minutes < 10 ? "0" +  this.gpobj2.minutes :  this.gpobj2.minutes
          this.gpobj2.seconds = parseInt(this.gpobj2.counts % 60);
          this.gpobj2.seconds = this.gpobj2.seconds < 10 ? "0" + this.gpobj2.seconds : this.gpobj2.seconds
        }
      },
      //展示拼团弹框信息
      showGroupDialog(type){
        if(localStorage.getItem('token')){
          this.clickOrder = type==1?this.detailObj.shoppingGroup.orderGroupList[0]:this.detailObj.shoppingGroup.orderGroupList[1];
          this.clickOrder.type = type;
          this.showGroupPurchDialog = true;
        }else{
            this.$router.push({
                path: "/login",
                query: {
                    name: "goodsDetail",
                    ...this.$route.query
                }
            }); 
          }
      },
      //跳转订单列表
      toOrderList(){
        this.$router.push({
          path:'/orderpage',
          query:{
            usego:1
          }
        })
      },
      //跳转拼团详情
      toGroup(){
        this.$router.push({
          path:'/grouppurchasedetailInvite',
          query:{
            id:this.detailObj.orderGroup?this.detailObj.orderGroup.id:'',
            showBack:1
          }
        })
      },
      //获取机构基本信息
        getBranchInformationByBid(){
            const params = {
                branchId: this.detailObj.mallTrainingGoodsDetail.branchId,
            };
            this.$api.entityGoodsDetail.getBranchInformationByBid(params).then((res) => {
                if (res.success) {
                    this.branchInfo = res.data;
                }
            });
        },
        //h5分享提示
        shareH5(){
          // if(this.isWechat){
          //   this.isShareShow = true;
          //   setTimeout(() => {
          //     this.isShareShow = false
          //   },5000)
          // }else{
          //   this.$toast('请使用浏览器自带分享进行分享')
          // }
          this.showSharePoster = true;
          if(this.isCreatedPoster){
            this.isCreatedPoster = false;
            this.randomNum = Math.floor(Math.random()*5);
            this.getBase64Image(this.sharePosterList[this.randomNum],1)
            this.getBase64Image(this.detailObj.picUrl,2);
          }
        },
      //客服
      handleServe() {
        if(localStorage.getItem('token')){
          this.onTrack('contact',{
              contact_type: '在线咨询',
              current_price: this.detailObj.salePrice,
          },false)
          window.qimoChatClick();
          // if(this.isApp&&localStorage.getItem('type')=='iOS'){
          //   setTimeout(()=>{
          //       let qimo_chatpup=document.getElementById('qimo_chatpup');
          //       console.log('元素',qimo_chatpup)
          //       console.log('高度',this.statusBarHeight)
          //       if(qimo_chatpup){
          //         qimo_chatpup.style.paddingTop = this.statusBarHeight + 'px';
          //         qimo_chatpup.style.boxSizing = 'border-box';
          //       }
          //   },300)
          // }

        }else{
          // if(this.isApp){
          //   this.onTrack('login_page_show',{
          //     show_reason: '客服咨询',
          //   },false)
          //   this.$WDJSBridge.jumpNAPage(JSON.stringify({pageName: 'login'})).then(res=>{
          //     console.log('跳转成功', res)
          //   }).catch(err=>{
          //     console.log('页面跳转错误', err)
          //   });
          // }else{
            let agentId = localStorage.getItem('detailAgentId') && parseInt(localStorage.getItem('detailAgentId'))
              this.$router.push({
                  path: "/login",
                  query: {
                    name: "goodsDetail",
                    agentId, 
                    ...this.$route.query,
                    consult:1,
                  }
              })
          // }
        }
      },
      //电话咨询
      handlePhone() {
        this.onTrack('contact',{
            contact_type: '电话咨询',
            current_price: this.detailObj.salePrice,
        },)
        this.$WDJSBridge.phone(JSON.stringify({
            phone:'4008555686',
        })).then(res=>{
            console.log('分享成功', res)
        }).catch(err=>{
            console.log('分享失败', err)
        })
      },
      shareOut(type){
        this.onTrack('commodity_share',{
            percentage_rate:0,
            is_promoter:false,
            current_price: this.detailObj.salePrice,
        })
        // if(this.isApp){
        //   console.log(this.detailObj);
        //   let recommendUserUcode = localStorage.getItem('token')?JSON.parse(localStorage.getItem('userInfo')).userUcode:'';
        //   this.$WDJSBridge.useShare(JSON.stringify({
        //       path:`/goodsDetail?goodsId=${this.detailObj.id}&goodsKind=${this.$route.query.goodsKind}&isWd=1&recommendUserUcode=${recommendUserUcode}`,
        //       title:this.detailObj.name,
        //       icon:this.detailObj.picUrl,
        //       desc:this.detailObj.mallTrainingGoodsDetail?this.detailObj.mallTrainingGoodsDetail.goodsSellingPoint:'',
        //       type:type,
        //       award:'',
        //   })).then(res=>{
        //       console.log('分享成功', res)
        //   }).catch(err=>{
        //       console.log('分享失败', err)
        //   })
        // }else{
          this.shareH5();
        // }
      },
      //跳转机构详情
      async toBranch(id){
        let url = await this.$publicFn.getSaasBranchDomain(id)
        // window.open(url+'/stationPage')
        // if(this.isApp){
        //   this.$WDJSBridge.useNewPage(JSON.stringify({
        //       url:url+'/stationPage',
        //       pageName:'stationPage'
        //   })).then(res=>{
        //       console.log('跳转成功', res)
        //   }).catch(err=>{
        //       console.log('页面跳转错误', err)
        //   })
        // }else{
          // window.open(url+'/stationPage')
          window.location.href = url+'/stationPage';
        // }
        // this.$router.push({
        //   path: '/stationPage',
        //   query:{
        //     id:id
        //   }
        // })
      },
      //埋点获取公共参数
      getLogParams() {
          const {branchId: aff_institution_id = '', branchName: aff_institution_name = ''} = this.detailObj.mallTrainingGoodsDetail || {};
          const {goodsId = '', goodsKind = ''} = this.$route.query;
          const {name = '', salePrice = '', basePrice = ''} = this.detailObj || {}
          const [
            commodity_firstcate = '', 
            commodity_secondcate = '', 
            commodity_thirdcate = ''
          ] = this.detailObj.mallTrainingGoodsDetail.categoryPath || [];
          return this.detailObj.shoppingGroup?{
              commodity_id: goodsId,
              goodsKinds: goodsKind,
              aff_institution_id: String(aff_institution_id),
              aff_institution_name,
              commodity_firstcate,
              commodity_secondcate,
              commodity_thirdcate,
              commodity_name: name,
              original_price: basePrice,
          }:{
              commodity_id: goodsId,
              goodsKinds: goodsKind,
              aff_institution_id: String(aff_institution_id),
              aff_institution_name,
              commodity_firstcate,
              commodity_secondcate,
              commodity_thirdcate,
              commodity_name: name,
              original_price: this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?salePrice:basePrice,
              current_price: this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.price:salePrice,
          }
      },
      //获取是否显示分享按钮、机构信息、本机构推荐课程
      configMenuInfor(){
            const frontendConfig = this.$store.state.dynamic.frontendConfig || [];
            frontendConfig.length && frontendConfig.filter( (item) => {
                switch(item.key) {
                    case  "is_show_courseGoodsInfo_courseRec":  // 培训商品详情页-显示本机构课程推荐
                        this.isShowTj = item.value == 'true' ? true : false
                        break;
                    case  "is_show_courseGoodsInfo_shareicon": // 培训商品详情页-显示分享按钮
                        this.isShowShareBtn = item.value == 'true' ? true : false
                        break;
                    case  "is_show_courseGoodsInfo_instInfo": // 培训商品详情页-显示机构信息
                        this.isShowBranch = item.value == 'true' ? true : false
                        break;
                    case  "is_show_downloadApp": // 分享配置
                        this.showConfig = item.value == 'true' ? true : false
                        break;
                    case  "is_show_QDh5_courseGoodsInfo_TELicon_ZXicon": // 渠道方-培训商品详情页是否显示电话按钮
                        this.isShowZXicon = item.value == 'true' ? true : false
                        break;
                    case  "is_show_goodsedit_courseInfo": //课程信息显示配置
                        this.is_show_goodsedit_courseInfo = item.value == 'true' ? true : false
                        break;
                     case  "is_show_my_points": //显示积分信息
                        this.is_show_my_points = item.value == 'true' ? true : false
                        break;
                    default:
                        break;
                }
            });
        },
      //获取视频信息播放
      // getVideo(){
      //   this.$api.entityGoodsDetail
      //   .detail({
      //     shortVideoId: this.detailObj.mallTrainingGoodsDetail.videoValue,
      //   })
      //   .then((res) => {
      //     if (res.code === 0) {
      //       const { title, coverUrl, resourceId } = res.data;

      //       this.coverUrl = coverUrl;

      //       this.getVideoPlayAuth(resourceId);

      //       return;
      //     }
      //   })
      // },
      getVideoPlayAuth() {
        return this.$api.entityGoodsDetail
          .videoPlayAuth({ shortVideoId: this.detailObj.mallTrainingGoodsDetail.videoValue,hashCover:true })
          .then((res) => {
            const playParams = {
              format: "m3u8",
              mediaType: "video",
            };
            this.$nextTick(() => {
              if(res.data?.sourceSing && (res.data?.sourceSing=='222' || res.data.sourceSing=='333')){
                  // 三方，222 格莱森的，333交通的
                  this.$refs.videoPlayerRef[0].initPlayer(res.data.playUrl,true)
              }else{
                  this.$refs.videoPlayerRef[0].initPlayer(res.data.playAuth,false, playParams)
              }
            })
            return res;
          })
          .catch((err) => err);
      },
      //推荐商品
        // getEntityGoodslist(){
        //     this.$api.entityGoodsDetail.getEntityGoodslist(this.entityParams).then((res)=>{
        //         console.log(res)
        //         if(res.code==0&&res.data.list){
        //             this.otherList.push(...res.data.list);
        //         }
        //         console.log('otherList',this.otherList)
        //     })
        // },
        //推荐课程
        findMallGoodsList(){
            this.$api.entityGoodsDetail.findMallGoodsList(this.pageParams,this.mallParams).then((res)=>{
                console.log(res)
                if(res.code==0&&res.data.list){
                    this.coruseList.push(...res.data.list);
                }
                console.log('coruseList',this.coruseList)
            })
        },
      handleScroll(){
            // console.log(window.scrollY)
            if(window.scrollY>=30){
                this.isScrollToBo = true;
            }else{
                this.isScrollToBo = false;
            }
        },
      // initPlayer() {
      //       this.playerOptions.sources[0].src = 'https://vodplay.wdyedu.com/500ae788145244fa99e536da11bcb744/0d676d776976441bb2908393f0ceac1d-be5387ab81d28dff2e95902a6fa68e93-sd.mp4'
      // },
      onChangeSwipe(index) {
            this.swipeCurrent = index;
            // const {goods} = this.detailData
            //当前类型
            // const currentItemType = goods[index].type;
            // console.log('player',this.$refs.videoPlayerinfo);
            // this.$refs.videoPlayerinfo.player.pause(false);
      },
      getQuicklyStudyInfo(){
        if(this.detailObj.goodsType ==  3) return
        // 2培训任务 1训练营
        const taskType = this.detailObj.goodsType
        this.$api.learning.quicklyStudy(this.detailObj.referId,taskType).then( res => {
          if(res.code == 0 && res.data){
            this.canToQuicklyStudy = true
            this.lastStudyCourseId = res.data.courseId
            this.taskId = res.data.taskId
            this.lastPlayItemId = res.data.lastPlayItemId
            this.firstStudy = res.data.firstStudy
          }
        })
      },
      onChange(){
        if(document.getElementsByTagName('video').length>0){
          var video = document.getElementsByTagName('video');
          for(let i=0;i<video.length;i++){
            video[i].pause()
          }
        }
        if(document.getElementsByTagName('audio').length>0){
          var audio = document.getElementsByTagName('audio');
          for(let j=0;j<audio.length;j++){
            audio[0].pause()
          }
        }
      },
      //返回
      back(){
        // console.log('isOpen',this.$store.state.isOpen)
        // console.log('isApp',this.isApp)
        if(!this.$store.state.isOpen){//试看弹框返回配置字段
          // if(this.isApp){
          //   if (this.$route.query.visit_referrer == 'home' || this.$route.query.visit_referrer == 'study' || !this.$route.query.visit_referrer) {
          //     this.$WDJSBridge.useBack().then(res=>{
          //         console.log('跳转成功', res)
          //         this.leavePage();
          //     }).catch(err=>{
          //         console.log('页面跳转错误', err)
          //     })
          //   } else {
          //     this.$router.go(-1 + this.len - self.history.length);
          //   }
          // }else{
            if(this.$route.query.isH5==1){
              // this.$router.go(-1 + this.len - self.history.length);
              this.$router.go(-1);
            }else{
              // if(this.isWd || this.$store.state.platform === 'c'){
              //   this.$router.push('/study?active=1');
              // }else{
                if(this.$route.query.isToHome){
                  this.$router.replace('/');
                }else{
                  this.$router.replace({
                    path:this.$route.query.backName?this.$route.query.backName:'/',
                    query:{
                      backPath:this.$route.query.backPath
                    }
                  })
                  // this.$router.push(this.$route.query.backName?this.$route.query.backName:'/goodsList');
                }
              // }
            }
          // }
        }else{
          this.$store.commit('setIsOpen',false);
          if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.back, false); //false阻止默认事件
          }
        }
      },
      // 目录大纲
      isToStudy(){
        if(this.detailObj.endTime&&this.detailObj.validityType==4){
          let lastTime = new Date(this.detailObj.endTime.replace(/-/g,'/')).getTime(); 
          let nowTime = new Date().getTime();
          if(lastTime>=nowTime){
            this.toStudy()
          }
        }else if(this.detailObj.endTime&&(this.detailObj.validityType==2||this.detailObj.validityType==3)){
          let lastTime = new Date(this.detailObj.endTime.replace(/-/g,'/')).getTime(); 
          let startTime = new Date(this.detailObj.startTime.replace(/-/g,'/')).getTime(); 
          let nowTime = new Date().getTime();
          if(lastTime>=nowTime&&startTime<=nowTime){
              this.toStudy()
          }
        }else{
          this.toStudy()
        }
        
      },
      toStudy(){
        if(this.detailObj.goodsType==1){
          this.$router.push({
            path:'/learning/Details',
            query:{
              id:this.detailObj.referId,
              goodsId:this.goodsId,
              goodsKind:this.$route.query.goodsKind,
              distributionUserId:this.$route.query.distributionUserId,
              backPath:this.$route.path
            }
          })
        }else if(this.detailObj.goodsType==2){
          this.$router.push({
            path:'/learning/task/detail',
            query:{
              id:this.detailObj.referId,
              goodsId:this.goodsId,
              goodsKind:this.$route.query.goodsKind,
              distributionUserId:this.$route.query.distributionUserId,
              backPath:this.$route.path,
              usego:1,
            }
          })
        }else if(this.detailObj.goodsType==3){
          this.$router.push({
            path:'/humanResting/hrDetails',
            query:{
              id:this.detailObj.referId,//测评id
              refId:this.goodsId,
              refType:2,
              goodsId:this.goodsId,
              distributionUserId:this.$route.query.distributionUserId,
              goodsKind:this.$route.query.goodsKind,
              pathName:this.$route.path
            }
          })
        }
      },
      // 快速学习
      quicklyStudy(){
        localStorage.setItem("faceidentify", 0);
        this.$router.push({
          path: "/scourse",
          query: {
            courseId: this.lastStudyCourseId,
            trainId: this.taskId,
            taskType: this.detailObj.goodsType,
            backType:this.detailObj.goodsType == 1? 2:1  //1返回学习页面培训任务tab，2返回训练营tab
          }
        });
      },
      //获取商品基本信息  
      getGoodsDetail(){
        return this.$api.courseGoodsDetail.findGoodsDetailById(
          {
            goodsId: this.goodsId,
          }
        )
        .then(res=>{
            // console.log(res);
            if(res.code===0){
              this.detailObj = res.data;
              if(this.isShowBranch){
                this.getBranchInformationByBid();
              }
              this.isData = true;
              // if(this.isShowShareBtn){
              //   this.getBase64Image(this.detailObj.picUrl,2);
              // }
              if(this.detailObj.shoppingGroup&&this.detailObj.shoppingGroup.orderGroupList.length){
                  this.detailObj.shoppingGroup.orderGroupList[0].expireTime = this.detailObj.shoppingGroup.orderGroupList[0].expireTime?this.detailObj.shoppingGroup.orderGroupList[0].expireTime.split('-').join('/'):'';
                  this.detailObj.shoppingGroup.orderGroupList[0].curTime = this.detailObj.shoppingGroup.orderGroupList[0].curTime?this.detailObj.shoppingGroup.orderGroupList[0].curTime.split('-').join('/'):'';
                  this.gpobj1.residue = new Date(this.detailObj.shoppingGroup.orderGroupList[0].expireTime).getTime() - new Date(this.detailObj.shoppingGroup.orderGroupList[0].curTime).getTime();
                  if(this.gpobj1.residue>0){
                      this.gpobj1.counts = parseInt(this.gpobj1.residue / 1000);
                      this.gpobj1.timer=setInterval(() => {
                          this.gpobj1.counts -= 1;
                          this.countDown(1);
                          if(this.gpobj1.counts<=0){
                              clearInterval(this.gpobj1.timer)
                          }
                      }, 1000);
                  }
                  if(this.detailObj.shoppingGroup.orderGroupList.length>=2){
                    this.detailObj.shoppingGroup.orderGroupList[1].expireTime = this.detailObj.shoppingGroup.orderGroupList[1].expireTime?this.detailObj.shoppingGroup.orderGroupList[1].expireTime.split('-').join('/'):'';
                    this.detailObj.shoppingGroup.orderGroupList[1].curTime = this.detailObj.shoppingGroup.orderGroupList[1].curTime?this.detailObj.shoppingGroup.orderGroupList[1].curTime.split('-').join('/'):'';
                    this.gpobj2.residue = new Date(this.detailObj.shoppingGroup.orderGroupList[1].expireTime).getTime() - new Date(this.detailObj.shoppingGroup.orderGroupList[1].curTime).getTime();
                    if(this.gpobj2.residue>0){
                        this.gpobj2.counts = parseInt(this.gpobj2.residue / 1000);
                        this.gpobj2.timer=setInterval(() => {
                            this.gpobj2.counts -= 1;
                            this.countDown(2);
                            if(this.gpobj2.counts<=0){
                                clearInterval(this.gpobj2.timer)
                            }
                        }, 1000);
                    }
                  }
                }
              if(this.detailObj.referId){
                this.getQuicklyStudyInfo();
                this.getList();
              }
              this.mallParams.exceptIdList = [res.data.id];
              this.mallParams.branchId = this.detailObj.mallTrainingGoodsDetail.branchId;
              if(this.detailObj.mallTrainingGoodsDetail.videoValue){
                this.getVideoPlayAuth();
              }
              if(this.isShowTj){
                this.findMallGoodsList();
              }
              this.onTrack('commodity_details_show',{
                  visit_referrer: this.fromName,
                  position_number:this.$route.query.position_number || '',
                  share_activity_source:this.$route.query.share_activity_source || '',
              })
            }else{
              this.isError = true;
              this.errorMessage = res.message;
            }
        }).catch(err=>{
            console.log('加载异常', err)
            this.isError = true;
            this.errorMessage = '加载异常';
        })
      },
      /**
       * 分销商品详情
       */
      getDistributionGoodsInfo(){
          const params = {
              id:this.goodsId
          }
          return this.$api.courseGoodsDetail.getDistributionGoodsInfo({params}).then(res => {
              if(res.code==0){
                this.detailObj = res.data;
                this.isData = true;
                // if(this.isShowShareBtn){
                //   this.getBase64Image(this.detailObj.picUrl,2);
                // }
                if(this.detailObj.shoppingGroup&&this.detailObj.shoppingGroup.orderGroupList.length){
                  this.detailObj.shoppingGroup.orderGroupList[0].expireTime = this.detailObj.shoppingGroup.orderGroupList[0].expireTime?this.detailObj.shoppingGroup.orderGroupList[0].expireTime.split('-').join('/'):'';
                  this.detailObj.shoppingGroup.orderGroupList[0].curTime = this.detailObj.shoppingGroup.orderGroupList[0].curTime?this.detailObj.shoppingGroup.orderGroupList[0].curTime.split('-').join('/'):'';
                  this.gpobj1.residue = new Date(this.detailObj.shoppingGroup.orderGroupList[0].expireTime).getTime() - new Date(this.detailObj.shoppingGroup.orderGroupList[0].curTime).getTime();
                  if(this.gpobj1.residue>0){
                      this.gpobj1.counts = parseInt(this.gpobj1.residue / 1000);
                      this.gpobj1.timer=setInterval(() => {
                          this.gpobj1.counts -= 1;
                          this.countDown(1);
                          if(this.gpobj1.counts<=0){
                              clearInterval(this.gpobj1.timer)
                          }
                      }, 1000);
                  }
                  if(this.detailObj.shoppingGroup.orderGroupList.length>=2){
                    this.detailObj.shoppingGroup.orderGroupList[1].expireTime = this.detailObj.shoppingGroup.orderGroupList[1].expireTime?this.detailObj.shoppingGroup.orderGroupList[1].expireTime.split('-').join('/'):'';
                    this.detailObj.shoppingGroup.orderGroupList[1].curTime = this.detailObj.shoppingGroup.orderGroupList[1].curTime?this.detailObj.shoppingGroup.orderGroupList[1].curTime.split('-').join('/'):'';
                    this.gpobj2.residue = new Date(this.detailObj.shoppingGroup.orderGroupList[1].expireTime).getTime() - new Date(this.detailObj.shoppingGroup.orderGroupList[1].curTime).getTime();
                    if(this.gpobj2.residue>0){
                        this.gpobj2.counts = parseInt(this.gpobj2.residue / 1000);
                        this.gpobj2.timer=setInterval(() => {
                            this.gpobj2.counts -= 1;
                            this.countDown(2);
                            if(this.gpobj2.counts<=0){
                                clearInterval(this.gpobj2.timer)
                            }
                        }, 1000);
                    }
                  }
                }
                if(this.detailObj.referId){
                  this.getQuicklyStudyInfo();
                  this.getList();
                }
                if(this.isShowBranch){
                  this.getBranchInformationByBid();
                }
                this.mallParams.exceptIdList = [res.data.id];
                this.mallParams.branchId = this.detailObj.mallTrainingGoodsDetail.branchId;
                if(this.detailObj.mallTrainingGoodsDetail.videoValue){
                  this.getVideoPlayAuth();
                }
                if(this.isShowTj){
                  this.findMallGoodsList();
                }
                this.onTrack('commodity_details_show',{
                    visit_referrer: this.fromName
                })
              }else{
                this.isError = true;
                this.errorMessage = res.message;
              }
          }).catch(err=>{
              console.log('加载异常', err)
              this.isError = true;
              this.errorMessage = '加载异常';
          })
      },
      //目录数据查询
      getList() {
        // console.log(this.detailObj.goodsType)
        if(this.detailObj.goodsType==1){
          //训练营目录
          this.$api.courseGoodsDetail.findTrainListById(
            {
              id: this.detailObj.referId,
            }
          )
          .then(res=>{
              // console.log(res);
              if(res.code===0){
                let tempArr = [];
                  let endData = [];
                  let timeArr = [];
                  let num = [];
                  res.data.menuList.forEach(tiem => {
                      tiem.childItemList = [];
                      num.push(tiem.lastStudyTime);
                      if (tiem.lastStudyTime !== null) {
                          timeArr.push(tiem.lastStudyTime);
                      }
                  });
                  this.timelength = timeArr.sort(function(a, b) {
                      return b > a;
                  });
                  res.data.menuList.forEach(item => {
                      tempArr.push(item.stageName);
                  });
                  let setName = [...new Set(tempArr)]; //.sort();
                  setName.forEach((el, index) => {
                      let datalist = [];
                      res.data.menuList.forEach(items => {
                          if (el === items.stageName) {
                              items.stageName = items.label
                              datalist.push(items);
                          }
                      });
                      endData.push({
                          stageName: el,
                          id: index,
                          type:0,
                          childItemList: datalist,
                          sort:1
                      });
                  });
                  this.catalogList = endData;
                  console.log(this.catalogList)
              }else{
                console.log(res.data.message)
              }
          })
        }
        else if(this.detailObj.goodsType==2){
          //培训任务目录
          this.$api.courseGoodsDetail.findTaskListById(
            {
              id: this.detailObj.referId,
              version:1
            }
          )
          .then(res=>{
              // console.log(res);
              if(res.code==0){
                this.catalogList = res.data.taskItemVoList;
              }
          })
        }

      },
      getQueryString(name) {
          /* eslint-disable */
        var search = window.location.search;
        //alert(search);
        var pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
        var matcher = pattern.exec(search);
        var items = null;
        if (null != matcher) {
            try {
                items = decodeURIComponent(decodeURIComponent(matcher[1]));
            } catch (e) {
                try {
                    items = decodeURIComponent(matcher[1]);
                } catch (e) {
                    items = matcher[1];
                }
            }
        }
        return items;
        /* eslint-disable */
      },
      formatDate(date) {
        return dayjs(date).format('YYYY.MM.DD') 
      },
      //立即报名
      enroll(type){
        // if(this.isWd){
        //   this.$toast('请点击右上角下载APP购买')
        // }else{
          if(this.detailObj.signUpEndTime && this.detailObj.signUpStartTime) {
            if(new Date() - new Date(this.detailObj.signUpEndTime.replace(/-/g, "/")) > 0) {
              this.$toast({
                message: '报名已过期',

              })
              return 
            } else if((new Date() - new Date(this.detailObj.signUpStartTime.replace(/-/g, "/"))) < 0){
              this.$toast({
                message: '报名未开始',
              
              })
              return 
            }
          }
          if(localStorage.getItem('token')){
              if( this.isDongkun ==='true' && this.isAgreeEmpower===0){ //东堃定制授权确认弹窗
                this.empowerDialog = true
                return
              }
                this.onTrack('buy_commodity_click',{
                    buy_type: this.detailObj.isFree ? '免费' : '付费',
                    current_price: type==1?(this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.price:this.detailObj.salePrice):this.detailObj.shoppingGroup.price,
                })
                if(this.detailObj.isFree){
                  localStorage.setItem('goodsOrderInfo','');
                  var data = {
                    activityGroupId:'',
                    totalMoney:type==2&&this.detailObj.shoppingGroup?this.detailObj.shoppingGroup.price:this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.price:this.detailObj.salePrice,
                    orderSource:2,
                    orderType:this.$route.query.goodsKind == 2 ? 4 : this.$route.query.goodsKind==1?localStorage.getItem('detailAgentId')?3:1:null,
                    agentId: localStorage.getItem('detailAgentId') || '',
                    distributionUserId:this.getQueryString('distributionUserId') || '',
                    shareUserInfo:sessionStorage.getItem('recommendUserUcode')?sessionStorage.getItem('recommendUserUcode'):'',
                    goodsList:[{
                        goodsId:this.goodsId,
                        goodsKinds:this.$route.query.goodsKind,
                        num:1,
                        promotionId:'',
                        salePrice:type==2&&this.detailObj.shoppingGroup?this.detailObj.shoppingGroup.price:this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.price:this.detailObj.salePrice
                    }],
                    realPay:type==2&&this.detailObj.shoppingGroup?this.detailObj.shoppingGroup.price:this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.price:this.detailObj.salePrice,
                    platformActivityRuleItemId:type==2&&this.detailObj.shoppingGroup?this.detailObj.shoppingGroup.activityRuleItemId:'',
                    platformSecKillActivityItemId:type==1&&this.detailObj.secKillActivity&&this.detailObj.secKillActivity.curPeriod?this.detailObj.secKillActivity.secKillActivityItemId:''
                  }
                  // if(this.isShowShareBtn) {
                  //   const {goodsId = '', goodsKind = ''} = this.$route.query;
                  //   this.$router.push({
                  //     path: "/gongxin_payment",
                  //     query: {
                  //       goodsId,
                  //       goodsKinds: goodsKind,
                  //       agentId: localStorage.getItem('detailAgentId') || '',
                  //       iswx: 0,
                  //     }
                  //   });
                  //   return false;
                  // }
                  this.$api.courseGoodsDetail.ordertoc({data}).then(res=>{
                    localStorage.setItem('goodsOrderInfo',JSON.stringify(res.data));
                    if(res.code==0){
                      if(res.data.placeOrderSuccess && res.data.realPayPrice > 0) {
                        this.$router.push({
                          path: "/gongxin_payment",
                          query: {
                              orderNo: res.data.orderNo,
                              agentId: localStorage.getItem('detailAgentId') || '',
                              iswx: 0,
                              isGroupGood:type==2?1:'',
                              goodsKinds: this.$route.query.goodsKind,
                          }
                        });
                      } else if(res.data.placeOrderSuccess && res.data.realPayPrice === 0){
                        this.showT = true;
                        setTimeout(() => {
                            this.showT = false;
                        }, 2000);
                        this.detailObj.isOrder = 1;
                      } else {
                        if(res.data.url) {
                          window.open(res.data.url, '_self')
                        } else {
                          this.$router.go(-1)
                        }
                      }
                    }else if(res.code==50001){
                      this.message = res.message;
                      this.showOrderTip = true;
                    }else{
                      Toast({
                        message: res.message,
                        duration: 2000
                      })
                    }
                  })
                }else{
                  this.$router.push({
                    path: "/gongxin_payment",
                    query: {
                      agentId:localStorage.getItem('detailAgentId') || '',
                      goodsId:this.$route.query.goodsId,
                      goodsKinds: this.$route.query.goodsKind,
                      isGroupGood:type==2?1:'',
                    }
                  });
                }
          }else{
              // if(this.isApp){
              //   this.onTrack('login_page_show',{
              //       show_reason: '购买',
              //   },false)
              //   this.$WDJSBridge.jumpNAPage(JSON.stringify({pageName: 'login'})).then(res=>{
              //     console.log('跳转成功', res)
              //   }).catch(err=>{
              //     console.log('页面跳转错误', err)
              //   });
              // }else{
                let agentId = localStorage.getItem('detailAgentId') && parseInt(localStorage.getItem('detailAgentId'))
                this.$router.push({
                  path: "/login",
                  query: {
                    name: "goodsDetail",
                    agentId, 
                    purchase:1,
                    ...this.$route.query
                  }
                });
              // }
              
          }
        // }
      },

    },



}

</script>


<style lang="less" scoped>
 @import "../asset/css/courseGoodsDetail.less";
 .empower-dialog {
   z-index:1999!important;
   color: #444;
   /deep/.van-dialog__content{
     padding:24px;
     max-height:380px;
     overflow: scroll;
   }
   /deep/p{
     text-align:left;
   }
   /deep/.van-dialog__footer{
     width:100%;
   }
 }
/deep/.van-overlay{
   z-index:1998!important;
 }
 .detail-foot {
   button {
      width: 690px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      background: #FF594A;
      border-radius: 44px;
      border: 0;
      font-size: 32px;
      margin-top: 10px;
      color: #ffffff;
      &.leftBtn {
          width: 177px;
          height: 80px;
          line-height: 80px;
          background: #fff;
          border-radius: 44px;
          border: 1px solid #DDDDDD;
          margin-right: 18px;
          color: #666666;
      }
      &.rightBtn {
          // width: 495px;
          height: 80px;
          line-height: 80px;
          background: #FF594A;
          border-radius: 44px;
          color: #FFFFFF;
      }
   }
 }
</style>
<style lang="less">
.van-notify--danger{
  background-color: #ee0a24;
  display: flex;
}
</style>

